// External libraries
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';

// Internal imports - state
import { store } from 'src/state/dynamic-store';
import { RootState } from '@state/root-state.ts';

// Internal imports - components
import { FunctionsComponentWrapper } from '@sharedComponents/functions/FunctionsComponent';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';

// Styles
import styles from './FunctionsPage.module.scss';

export function FunctionsPage() {
  const { t } = useTranslation(['layouts']);
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId ?? '');

  return (
    <>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.functions.page') }]} />
      <Paper className={styles.container}>
        <FunctionsComponentWrapper organizationId={organizationId} store={store} />
      </Paper>
    </>
  );
}
